import { GAME_STATE_KEY, PROGRESS_KEY, RANDOM_PUZZLE_KEY, ARCHIVE_MONTH_KEY, puzzleKey } from "./constants";
import { clearGameState } from "../hooks/useGame";

/**
 * Reset puzzle data based on the current URL path.
 * - Puzzle page (/7x7/2026-03-15): resets only that puzzle
 * - Any other page: resets all data
 */
export function handleReset(path: string): void {
  const puzzleMatch = path.match(/^\/(7x7|9x9)\/(\d{4}-\d{2}-\d{2})$/);

  if (puzzleMatch) {
    resetPuzzle(puzzleMatch[1], puzzleMatch[2]);
  } else {
    resetAll();
  }
}

export function resetPuzzle(size: string, date: string): void {
  const key = puzzleKey(size, date);
  clearGameState(key);
  try {
    const pr = JSON.parse(localStorage.getItem(PROGRESS_KEY) || "{}");
    delete pr[key];
    localStorage.setItem(PROGRESS_KEY, JSON.stringify(pr));
  } catch { /* ignore */ }
}

export function resetAll(): void {
  localStorage.removeItem(PROGRESS_KEY);
  // clearGameState removes entries; for full reset, remove the whole key
  localStorage.removeItem(GAME_STATE_KEY);
  localStorage.removeItem(RANDOM_PUZZLE_KEY);
  localStorage.removeItem(ARCHIVE_MONTH_KEY);
}
